<template>
  <b-modal :id="modalId" modal-class="guide-modal" hide-backdrop centered>
    <template #modal-header="{ close }">
      <b-avatar
        variant="info"
        src="https://lh3.googleusercontent.com/a-/AOh14GhLH09iTdcfTCDXXmr5aZ_7VRuCzNCR-VLef0OZvg"
        class="mr-3"
      ></b-avatar>
      <span class="mr-auto">Savalas Colbert, Founder and CEO</span>
      <!-- Emulate built in modal header close button action -->
      <span class="close-icon" @click="$bvModal.hide(modalId)">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="10.6667"
                height="10.6667"
                fill="white"
                transform="translate(6.6665 6.66675)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
    </template>

    <template #default="{ hide }">
      <b-img
        src="https://picsum.photos/1024/400/?image=41"
        fluid
        alt="Responsive image"
      ></b-img>
    </template>

    <template #modal-footer="{ ok, cancel, hide }">
      <b-button size="sm" variant="info" @click="startTour()">
        Show Me Tour
      </b-button>
      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="hide(modalId)">
        Ok, Got It
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { tourblog } from "./_tourBlog.json";
import Vue from "vue";
import VueShepherd from "vue-shepherd";

Vue.use(VueShepherd);

export default {
  name: "TutorialAndTour",
  props: {
    videoURL: {
      type: String
    },
    tour: {
      type: Array,
      default: () => {
        return tourblog;
      }
    }
  },
  data() {
    return {
      modalId: "modal-tutorial",
      visible: false
    };
  },
  created() {},
  computed: {},
  methods: {
    startTutoial() {
      this.$bvModal.show(this.modalId);
    },
    startTour() {
      this.$bvModal.hide(this.modalId);

      const tour = this.$shepherd({
        useModalOverlay: true
      });

      tourblog.forEach(step => {
        //swap actions
        if (step.buttons) {
          step.buttons.forEach(button => {
            button.action = this.swapFunc(tour, button.action);
          });
        }

        tour.addStep(step);
      });

      tour.start();
    },
    swapFunc(tour, methodName) {
      switch (methodName) {
        case "cancel":
          return tour.cancel;
        case "next":
          return tour.next;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~shepherd.js/dist/css/shepherd.css";

.guide-modal___BV_modal_content_ {
  border-radius: 16px;
}
.close-icon {
  position: absolute;
  top: 24px;
  right: 20px;
  cursor: pointer;
}
</style>
